import { seo } from "../../../common/helpers/seo";

import lazyComponent from "./lazy";


export default {
    component: lazyComponent,
    renderSeo: ({ dispatch }, allMessage, lang) => {
        return seo({ title: allMessage["menu.homeworks"], allMessage, lang });
    },
};
